export default {
    methods: {
        fixNumber(number) {
            return Number(number.toFixed(2));
        }
    },
}